import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { DEFAULT_LANGUAGE, LANGUAGES, Language } from './languages'
import de from './de'
import en from './en'
import es from './es'
import ca from './ca'

const isBrowser = typeof window !== 'undefined'

const chain = i18n.use(initReactI18next)
if (isBrowser) chain.use(LanguageDetector)

chain.init({
  resources: {
    [Language.DE]: { translation: de },
    [Language.EN]: { translation: en },
    [Language.ES]: { translation: es },
    [Language.CA]: { translation: ca },
  },
  lng: isBrowser ? undefined : DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: LANGUAGES,
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
    lookupQuerystring: 'lang',
    caches: ['localStorage'],
  },
  interpolation: {
    escapeValue: false,
  },
  showSupportNotice: false,
})

export default i18n
